module.exports = __webpack_public_path__ + "media/2_2.e9eb3690.wav";